<template>
  <div>
    <b-modal
        :title="$t('Join meeting requests')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="lg"
        no-close-on-backdrop lazy>
      <div class="mb-3">
        <button class="btn-trans-small mr-1" @click="selectAll"><img src="images/ico-check-double-solid-16.png"/>
          {{ $t("Select all") }}
        </button>
        <button class="btn-trans-small mr-1" @click="approvedRequests()"><img
            src="images/ico-check-circle-solid-16.png"/> {{ $t("Approved") }}
        </button>
        <button class="btn-trans-small" @click="deleteRequests()"><img src="images/ico-trash-solid-16.png"/>
          {{ $t("Delete") }}
        </button>
      </div>
      <vue-custom-scrollbar class="list-requests" @ps-y-reach-end="scroll">
        <b-card class="request-item" v-for="(request, index) in requests" :key="index"
                :data-read="request.IsRead ? 'true' : 'false'"
                :data-selected="request.IsSelected ? 'true' : 'false'">
          <div class="d-flex">
            <div class="request-icon" @click="changeCheckStatus(request)">
              <b-icon :icon="request.IsSelected ? 'check2' : 'question'"></b-icon>
            </div>
            <div class="request-content" @click="viewRequest(request)">
              <div class="content">{{ request.Title }}</div>
              <div class="time">{{ request.Date }}</div>
            </div>
          </div>
        </b-card>
      </vue-custom-scrollbar>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
    <NotificationJIRequestModal ref="notificationJIRequestModal" @open="requestOpened" @approved="requestApproved"/>
  </div>
</template>

<script>
import joinRequestService from "../services/join_request_service";
import dialogHelper from "../helpers/dialog_helper";
import NotificationJIRequestModal from "./NotificationJIRequestModal";

export default {
  name: "JoinRequestsModal",
  components: {NotificationJIRequestModal},
  data: function () {
    return {
      show: false,
      loading: false,
      ended: false,
      requests: []
    }
  },
  create() {
  },
  watch: {
    "show": function (newValue) {
      if (newValue)
        return;

      this.clearData();
    }
  },
  methods: {
    open() {
      let _ = this;
      this.show = true;
      this.reload();
    },
    clearData() {
      this.ended = false;
      this.requests = [];
    },
    reload() {
      this.clearData();
      this.loadRequests();
    },
    async loadRequests() {
      if (this.ended)
        return;

      this.loading = true;
      let totalRequests = this.requests.length;
      let response = await joinRequestService.list(totalRequests === 0 ? {} : {
        date: this.requests[totalRequests - 1].CreatedDate
      })
      this.loading = false;

      if (!response) return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      const requests = JSON.parse(response.substr(3));
      this.ended = requests.length < 50;

      let titlePattern = this.$t("{0} (TranS ID: {1}) sent request to you to join meeting room {2}");
      requests.forEach(x => {
        x.IsSelected = false;
        x.Title = titlePattern.replace("{0}", x.Fullname).replace("{1}", x.TransID).replace("{2}", x.Schedule);
        this.requests.push(x);
      });
    },
    scroll() {
      if (this.ended || this.loading)
        return;

      this.loadRequests();
    },
    selectAll() {
      if (this.requests.find(x => x.IsSelected === false))
        this.requests.forEach(x => x.IsSelected = true);
      else
        this.requests.forEach(x => x.IsSelected = false);
    },
    async deleteRequests() {
      let ids = this.requests.filter(x => x.IsSelected).map(x => x.RequestID);
      if (ids.length === 0) {
        dialogHelper.alert("Please select request (s) to delete!", "warning");
        return;
      }

      let result = await dialogHelper.confirm("Are you sure to delete this request (s)?")
      if (!result)
        return;

      this.loading = true;
      let response = await joinRequestService.deleteRequests(ids);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.reload();
    },
    async approvedRequests() {
      let ids = this.requests.filter(x => x.IsSelected).map(x => x.RequestID);
      if (ids.length === 0) {
        dialogHelper.alert("Please select request (s) to approved!", "warning");
        return;
      }

      let result = await dialogHelper.confirm("Are you sure to approved this request (s)?")
      if (!result)
        return;

      this.loading = true;
      let response = await joinRequestService.approveRequests(ids);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        this.loading = false;
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.reload();
    },
    changeCheckStatus(request) {
      request.IsSelected = request.IsSelected ? false : true;
    },
    viewRequest(request) {
      this.$refs.notificationJIRequestModal.open(request.RequestID, request.RequestID);
    },
    requestOpened (idNotify, idRequest){
      let request = this.requests.find(x => x.RequestID == idRequest);
      if (request != null)
        request.IsRead = true;
    },
    requestApproved (idNotify, idRequest) {
      this.requests = this.requests.filter(x => x.RequestID != idRequest);
    }
  }
}
</script>

<style scoped>
.list-requests {
  max-height: 400px;
}


.request-item {
  background-color: rgba(255, 255, 255, 0.2);
  border: none;
  margin-bottom: 5px;
}

.request-item[data-read="false"] {
  background-color: rgba(0, 0, 200, 0.2);
  font-weight: 600;
}

.request-item:hover {
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
}

.request-item[data-read="false"]:hover {
  background-color: rgba(0, 0, 200, 0.4);
}

.request-item[data-selected="true"] {
  background-color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
}

.request-item[data-selected="true"][data-read="false"] {
  background-color: rgba(0, 0, 200, 0.6);
  font-weight: 600;
}

.request-item .card-body {
  padding: 10px;
}

.request-icon {
  display: block;
  height: 40px;
  width: 40px;
  line-height: 38px;
  background-color: #ffffff;
  border-radius: 50%;
  color: #39b54b;
  text-align: center;
  font-size: 20px;
  margin-right: 10px;
  margin-top: 5px;
}

.request-content {
  flex-direction: column;
  flex-basis: 0%;
  flex-grow: 1;
}

.request-content .content {
  display: -webkit-box;
  width: 100%;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-height: 1.25;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  margin-bottom: 3px;
  font-size: 15px;
}

.request-content .time {
  font-size: 12px;
  line-height: 12px;
}
</style>